<script setup lang="ts">
withDefaults(
  defineProps<{
    modelValue?: boolean
  }>(),
  {
    modelValue: false,
  },
)
const emits = defineEmits<{
  'update:model-value': [value: boolean]
  'on-success-login': []
}>()
defineSlots<{ header(): any }>()

const currentStep = ref('Email')

const modalSize = computed(() => {
  return currentStep.value === 'SignUp' ? 's' : 'xs'
})
</script>

<template>
  <BaseModalV2
    :has-close-button="currentStep === 'Email'"
    :model-value="modelValue"
    :size="modalSize"
    active-esc-mode
    @close="emits('update:model-value', false)"
    @update:model-value="emits('update:model-value', $event)"
  >
    <template #content>
      <AuthModalWrapper
        @current-step="currentStep = $event"
        @on-success-login="emits('on-success-login')"
      >
        <template #header>
          <slot name="header" />
        </template>
      </AuthModalWrapper>
    </template>
  </BaseModalV2>
</template>
